import * as React from 'react';
import SvgIcon from '../../SvgIcon';
const SvgPrinter = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M21 6.3h-.65v-2a3 3 0 0 0-3-3H6.7a3 3 0 0 0-3 3v2H3a3 3 0 0 0-3 3v5.07a3 3 0 0 0 3 3h.68v2.42a3 3 0 0 0 3 3h10.66a3 3 0 0 0 3-3v-2.5H21a3 3 0 0 0 3-3V9.26a3 3 0 0 0-3-2.96M6.1 4.29a.61.61 0 0 1 .6-.59h10.64a.6.6 0 0 1 .6.59v2H6.1Zm11.84 15.42a.6.6 0 0 1-.6.59H6.7a.61.61 0 0 1-.6-.59v-6.93h11.84Zm2.4-9.11a1.4 1.4 0 0 1-.95.36 1.42 1.42 0 1 1 0-2.84 1.41 1.41 0 0 1 .95 2.48m-3.65 4.52a.86.86 0 0 1-.86.84H8.37a.85.85 0 1 1 0-1.69h7.46a.86.86 0 0 1 .86.85m-2.78 2.72a.86.86 0 0 1-.87.85H8.37a.86.86 0 1 1 0-1.71H13a.87.87 0 0 1 .91.86"
    }));
export default SvgPrinter;
